export default __webpack_public_path__ + "static/tecalis-students_04-a370a9831692e87ae53716c9ef64465e.png";